var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10.977,
    viewBox: "0 0 11 10.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2267",
    "data-name": "Group 2267",
    transform: "translate(-175.502 -488.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3501",
    "data-name": "Path 3501",
    d: "M18068.5-4977.353v2.644",
    transform: "translate(-17892 5473)",
    fill: "none",
    stroke: "#feaf27",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3502",
    "data-name": "Path 3502",
    d: "M18068.5-4977.353v4.307",
    transform: "translate(-17889 5471.337)",
    fill: "none",
    stroke: "#feaf27",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3503",
    "data-name": "Path 3503",
    d: "M18068.5-4977.353v6.17",
    transform: "translate(-17886 5469.474)",
    fill: "none",
    stroke: "#feaf27",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3504",
    "data-name": "Path 3504",
    d: "M18068.5-4977.353v8.977",
    transform: "translate(-17883 5466.667)",
    fill: "none",
    stroke: "#feaf27",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.ea0580b4302ef5243aa9a829c97afb3c.svg";
export { ForwardRef as ReactComponent };